module.exports = "/_next/static/images/bg-ok-5dba65a7.png";